import React, {useMemo} from 'react';
import {CheckboxProps} from './types';
import {Layout} from '../layout';
import {Icon} from '../icons';
import {Text} from '../text';
import {CheckmarkStyleMap} from './styles';
import {useTheme} from '../../theme';

export const Checkbox: React.FC<CheckboxProps> = ({
  kind = 'Default',
  label,
  state,
  onPress,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => {
    return {
      backgroundColor: CheckmarkStyleMap[kind][state].backgroundColor,
      borderColor: CheckmarkStyleMap[kind][state].borderColor,
      borderWidth: CheckmarkStyleMap[kind][state].borderWidth,
      borderStyle: CheckmarkStyleMap[kind][state].borderStyle,
    };
  }, [kind, state]);

  return (
    <Layout horizontal>
      <Layout
        borderWidth={styles.borderWidth}
        borderColor={styles.borderColor}
        borderStyle={styles.borderStyle}
        borderRadius={'4'}
        width={22}
        height={22}
        backgroundColor={styles.backgroundColor}
        centered
        onPress={onPress}>
        <Layout
          width={theme.spacing['18']}
          height={theme.spacing['10']}
          centered>
          {state === 'Checked' ? (
            <Icon name={'checkmarkThick'} inverse size="24" />
          ) : null}
          {state === 'Indetermined' ? (
            <Icon name={'minusThick'} inverse size="24" />
          ) : null}
        </Layout>
      </Layout>
      {label ? (
        <Layout centered paddingLeft={'10'}>
          <Text variant="paragraph_14_default">{label}</Text>
        </Layout>
      ) : null}
    </Layout>
  );
};
